module.exports = __webpack_public_path__ + "img/51.3bf52608.png";